import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import Box from "@mui/material/Box";
import { styled } from "@material-ui/styles";
// component, hooks
import IntroBanner from "../common/IntroBanner";
// store
// config,utils
import { featureIntroSetting } from "./option";

// style

const StyledBgBox = styled(
  Box,
  {}
)(({ theme }) => ({
  paddingTop: "128px",
  paddingBottom: "158px",
  paddingRight: "0px",
  paddingLeft: "0px",
}));

const FeatureIntroSec = () => (
  // props

  // route,intl
  // store
  // local state

  // hooks

  <StyledBgBox>
    {featureIntroSetting.map(
      ({ title, content, tag, imgSrc, imgSrcSet, bgColor, direction }, idx) => (
        <IntroBanner
          key={idx.toString()}
          title={title}
          content={content}
          imgSrc={imgSrc}
          imgSrcSet={imgSrcSet}
          tag={tag}
          direction={direction}
          bgColor={bgColor}
        />
      )
    )}
  </StyledBgBox>
);
FeatureIntroSec.propTypes = {};

FeatureIntroSec.defaultProps = {};

export default FeatureIntroSec;
